export function safeLocalStorage(
  method: "get",
  key: string,
  value?: undefined
): string | null;
export function safeLocalStorage(
  method: "set",
  key: string,
  value: string
): null;

export function safeLocalStorage(
  method: "get" | "set",
  key: string,
  value: any
) {
  try {
    const result =
      method === "set"
        ? localStorage.setItem(key, value)
        : localStorage.getItem(key);
    return method === "set" ? null : result;
  } catch (err) {
    console.error("LocalStorage error: ", err);
    return null;
  }
}

export function setEntryId(projectId: string, id: string) {
  return safeLocalStorage("set", `${projectId}-eid`, id);
}

export function getEntryId(projectId: string) {
  return safeLocalStorage("get", `${projectId}-eid`);
}
